import { Helmet } from "react-helmet";
import {
  Avatar,
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Collapse,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  Paper,
  Icon,
  Step,
  Stepper,
  StepIcon,
  StepLabel,
  StepContent,
  TextField,
  Tabs,
  Tab,
  Typography,
  StepConnector,
  FormHelperText
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams, Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeStyles, styled } from "@mui/styles";
import cssVariables from "../../../../theme/cssVariables";
import ApexCharts from "react-apexcharts";
import myFeedback from "../../../../services/myFeedback.service";
import IconFeedback from "../../../../constants/IconFeedback";

import { ReactComponent as MarkIcon } from "../../../../assets/icons/mark.svg";
import { ReactComponent as CheckIcon } from "../../../../assets/icons/check-2.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/icons/cancel.svg";
import { ReactComponent as DocIcon } from "../../../../assets/icons/document.svg";
import { ReactComponent as MinimizeIcon } from "../../../../assets/icons/minimized.svg";
import { ReactComponent as MaximizeIcon } from "../../../../assets/icons/maximized.svg";
import { ReactComponent as DownArrowIcon } from "../../../../assets/icons/down-arrow.svg";
import { ReactComponent as SubmitButton } from "../../../../icons/submit-button.svg";
import { ReactComponent as ArrowRight } from "../../../../icons/arrow-circle-right.svg";
import { ReactComponent as ArrowBottom } from "../../../../icons/arrow-circle-bottom.svg";
import { ReactComponent as StatusGraphIcon } from "../../../../icons/status-graph.svg";
import { ReactComponent as GoalWeightIcon } from "../../../../icons/goal-weight.svg";
import { ReactComponent as TooltipIcon } from "../../../../assets/images/tooltip.svg";
import { ReactComponent as FilterIcon } from "../../../../icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as LinkIcon } from "../../../../icons/link.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import { ReactComponent as SubmitIcon } from "../../../../assets/images/submitIcon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/edit.svg";
import planningImg from "../../../../assets/images/home/planning.svg";

import angry from "../../../../assets/images/angry.png";
import bored from "../../../../assets/images/bored.png";
import lazy from "../../../../assets/images/lazy.png";
import worried from "../../../../assets/images/worried.png";
import disappointed from "../../../../assets/images/disappointed.png";
import accomplished from "../../../../assets/images/accomplished.png";
import loved from "../../../../assets/images/loved.png";
import joyful from "../../../../assets/images/joyful.png";
import happy from "../../../../assets/images/happy.png";
import excited from "../../../../assets/images/excited.png";

import fileBrowser from "../../../../icons/file-browser.svg";
import personImg from "../../../../assets/icons/person-fill.svg";

import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/inbox/ConfirmDialog";
import ConfirmDialogFeedback from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import ReadMoreDialog from "../../../../components/inbox/ReadMoreDialog";

// rest service
import {
  getInboxDetail,
  postWorkflowSubmit,
  postWorkflowCancel,
  postWorkflowReject,
  postWorkflowRequest,
} from "../../../../actions/inboxKpi";
import * as Util from "../../../../services/global.service";

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  input: {
    '& div > input': {
      height: '12px',
      position: "relative"
    }
    , "&.MuiFormControl-root": { "margin-top": "10px" }
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  paperDetailContainer: {
    backgroundColor: `${cssVariables.color.gray}!important`,
    width: "100%",
    padding: "1.5rem",
  },
  blueBg: {
    background: "#6694CC",
  },
  profileContainer: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  statusBadge: {
    width: "150px",
    borderRadius: "5px",
    padding: "8px 10px",
    textAlign: "center",
  },
  draftBg: {
    background: "#EFB76D26",
  },
  draftText: {
    color: "#EFB76D",
  },
  pendingBg: {
    background: "#F280261A",
  },
  pendingText: {
    color: "#EFB76D",
  },
  approveBg: {
    background: "#5DA19626",
  },
  approveText: {
    color: "#5DA196",
  },
  rejectedBg: {
    background: "#CC605826",
  },
  rejectedText: {
    color: "#CC6058",
  },
  grayBg: {
    background: "#82828226",
  },
  grayText: {
    color: "#828282!important",
  },
  cancelBg: {
    background: "#82828226",
  },
  cancelText: {
    color: "#828282",
  },
  cancelPendingBg: {
    background: "#82828226",
  },
  cancelPendingText: {
    color: "#828282",
  },
  grayStepBg: {
    background: "#828282",
  },
  stepTextRoot: {
    fill: "#939393!important",
  },
  processBg: {
    background: "rgba(239, 183, 109, 0.15)",
  },
  completedBg: {
    background: "rgba(93, 161, 150, 0.15)",
  },
  redBg: {
    background: "rgba(204, 96, 88, 0.15)",
  },
  processText: {
    color: "#EFAD0A!important",
  },
  completedText: {
    color: "#5DA196!important",
  },
  redText: {
    color: "#CC6058!important",
  },
  paddingRight_8: {
    paddingRight: "8px",
  },
  paddingRight_0: {
    paddingRight: "0!important",
  },
  disabledSvg: {
    "& > path": {
      fill: "#A0A0A0",
    },
    "& g > path": {
      fill: "#A0A0A0",
    },
  },
  clipPath: 'inset(0% 0% -2px 0% round 2px)',
  root: {
    fontSize: "16px",
  },
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    }
  },
  inactiveSvg: {
    "& > path": {
      fill: "#D0D0D0"
    },
    '& g > path': {
      fill: '#D0D0D0'
    },
  },
  statusGraph: {
    "& > path": {
      fill: "#fff"
    }
  },
  internalIcon: {
    "& > path": {
      fill: "#fff"
    },
    '& g > path': {
      fill: '#fff'
    },
  },
  linkIcon: {
    "& > path": {
      fill: "#A0A0A0"
    },
    '& g > path': {
      fill: '#A0A0A0'
    },
  },
  calendarIcon: {
    '& > path': {
      fill: "#000"
    },
    '& g > path': {
      fill: "#000"
    },
  },
  paginationRoot: {
    color: `${cssVariables.color.primary}`,
    backgroundColor: "white!important",
    minWidth: "30px!important",
    padding: "5px!important",
  },
  paginationSelected: {
    color: "white!important",
    border: "1px solid rgba(93, 161, 150, 0.5)!important",
    backgroundColor: `${cssVariables.color.primary}!important`,
    minWidth: "30px!important",
    padding: "5px!important",
  },
  clickable: {
    cursor: "pointer",
    transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    '&:hover': {
      color: 'rgb(65, 112, 105) !important'
    }
  },
  fillDisable: {
    '& > path': {
      fill: '#A0A0A0'
    },
    '& g > path': {
      fill: '#A0A0A0'
    },
  },
  btn: {
    '& > svg': {
      marginLeft: "10px"
    }
  },
  boxIcon: {
    "&:hover": {
      transition: "0.5s",
      animation: `$shadow 1.2s infinite`,
      backgroundColor: "#5DA196",
    },
  },
});

function BarLegend(props) {
  const data = props.data;
  let row = [];
  let percent = (data) => {
    let sumpercent = 0;
    if (data > 0) {
      sumpercent = (data / props.total) * 100;
    }
    return sumpercent;
  };
  for (var i = 0; i < data.series.length; i++) {
    row.push(
      <Box
        key={data.series[i].name}
        display="flex"
        alignItems="center"
        sx={{ width: "100%" }}
      >
        <Box sx={{ width: "10%" }}>
          <div
            className="bar-legend-circle"
            style={{ backgroundColor: data.options.colors[i] }}
          ></div>
        </Box>
        <Box sx={{ width: "40%" }}>
          <Typography
            style={{
              fontSize: "14px",
              color: "#939393",
            }}
          >
            {" "}
            {data.series[i].name}
          </Typography>
        </Box>
        <Box sx={{ width: "10%" }}>
          <Typography
            style={{
              fontSize: "14px",
              color: "#939393",
            }}
          >
            {" "}
            {data.series[i].data[0].toFixed(2)}
          </Typography>
        </Box>
        <Box sx={{ width: "20%" }}>
          <Typography
            style={{
              fontSize: "14px",
              color: "#939393",
            }}
          >
            {" "}
            {data.options.unit}
          </Typography>
        </Box>
        <Box sx={{ width: "10%" }}>
          <Typography
            style={{
              fontSize: "14px",
              color: "#939393",
            }}
          >
            ({percent(data.series[i].data[0]).toFixed(2)}%)
          </Typography>
        </Box>
      </Box>
    );
  }
  return row;
}

function StylePaper(props) {
  return (
    <Paper sx={{ padding: "20px" }} {...props}>
      {props.children}
    </Paper>
  );
}

const CustomStepContent = (props) => {
  const { t } = useTranslation();
  const language = localStorage.getItem("lang");
  const classes = useStyles();
  let step = props.data;
  let proxy = props.dataProxy;
  let divider = props.divider ?? null
  return (
    <StepContent>
      <Box sx={{ display: "flex" }}>
        {step.employeeStatus === 3 ? (
          <div
            className={`${classes.profileContainer}`}
            style={{
              width: 40,
              height: 40,
              background: "linear-gradient(0deg, #CCCCCC, #CCCCCC)",
            }}
          >
            <img
              style={{ width: 30, height: 30 }}
              src={personImg}
              alt="profile"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = personImg;
              }}
            />
          </div>
        ) : step.profileImage !== "" || step.profileImage ? (
          <img
            className={`${classes.profileContainer}`}
            style={{
              width: 40,
              height: 40,
              opacity: step.employeeStatus === 2 ? "0.3" : "1",
            }}
            src={step.employeeStatus === 3 ? personImg : step.profileImage}
            alt="profile"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = personImg;
            }}
          />
        ) : (
          <Avatar
            className={`${classes.profileContainer}`}
            style={{
              width: 40,
              height: 40,
              opacity: step.employeeStatus === 2 ? "0.3" : "1",
            }}
          />
        )}
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            marginLeft: "10px",
          }}
        >
          {step.employeeStatus === 3 ? (
            <React.Fragment>
              <Typography variant="s14_fw300">{t("label.noData")}</Typography>
              <Typography variant="s14_fw300">{t("label.date")}: -</Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography
                variant="s14_fw600"
                sx={{ opacity: step.employeeStatus === 2 ? "0.5" : "1" }}
              >
                {language === "en-US" ? step.fullname_en : step.fullname_th}
              </Typography>
              <Typography
                variant="s14_fw300"
                sx={{ opacity: step.employeeStatus === 2 ? "0.5" : "1" }}
              >
                {t("label.date")}: {Util.dateDayTimeFormat(step.date.replace(/[A-Za-z]/g, " ")) ?? "-"}
              </Typography>
            </React.Fragment>
          )}
          {step.employeeStatus === 3 ? (
            <React.Fragment>
              <Typography variant="s14_fw300">{t("label.noData")}</Typography>
              {/* <Typography variant="s14_fw300">{t("label.date")}: -</Typography> */}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {((step.proxy !== undefined && step.proxy !== "") || (step.submitted_by !== undefined && step.submitted_by !== "")) &&
                <Box sx={{ background: "#FAFAFA", "border-radius": "4px", padding: "3px 8px", margin: "10px 0px" }} >
                  {(step.submitted_by !== undefined && step.submitted_by !== "") &&
                    <>
                      <Typography fontSize={12} lineHeight="18px" color="#9E9E9E"> {"Submitted by:"}</Typography>
                      <Typography fontSize={12} lineHeight="18px" color="#5DA196">{Util.formatData(language === "en-US" ? step?.submitted_by?.fullname_en : step?.submitted_by?.fullname_th, "-")}</Typography>
                    </>
                  }
                  {(step.proxy !== undefined && step.proxy !== "") &&
                    <>
                      <Typography fontSize={12} lineHeight="18px" color="#9E9E9E"> {"Proxy by:"}</Typography>
                      <Typography fontSize={12} lineHeight="18px" color="#5DA196">{Util.formatData(step.proxy, "-")}</Typography>
                    </>
                  }
                </Box>
              }
            </React.Fragment>
          )}
          {step.status ? (
            <div
              className={`${classes.statusBadge} ${classes[Util.StepStatusColor(step) + "Bg"]
                }`}
            >
              <Typography
                className={`${classes[Util.StepStatusColor(step) + "Text"]}`}
                fontWeight={500}
              >
                {/* { 
                  step.mark === "requester" ?
                    step.status === "pending" ?
                    (t(`label.status.done`))
                    : step.status === "cancel" ?
                    t(`label.status.cancelRequest`)
                    : step.status === "cancel_pending" || step.status === "cancel_cancel" ?
                    t(`label.status.cancelPendingRequest`)
                    : t(`label.status.${step.status}`)
                  : t(`label.status.${step.status}`)
                } */}
                {step.status_name}
              </Typography>
            </div>
          ) : (
            <></>
          )}
          {step.comment ? (
            <React.Fragment>
              <Typography variant="h6" style={{ marginTop: "10px" }}>
                {t("inbox.label.comment")}:
              </Typography>
              <Typography
                variant="s14_fw400"
                style={{
                  marginTop: "0",
                  wordBreak: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                  color: "#404349",
                }}
                id="readmore"
              >
                {step.comment}
              </Typography>
              <Typography
                variant="s14_fw400"
                textAlign="center"
                onClick={() => props.readmore(step ?? {})}
                className="clickable"
              >
                <u>{t("inbox.label.readMore")}</u>
              </Typography>
            </React.Fragment>
          ) : (
            <></>
          )}
        </Box>
      </Box>
      {divider ? <Divider sx={{ margin: "10px 0" }} /> : <></>}
    </StepContent >
  );
};

const InboxDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const language = localStorage.getItem("lang");
  const params = useParams();
  const navigate = useNavigate();
  const inboxDetail = useSelector((state) => state.Inbox.inboxDetail);
  const [approvalData, setApprovalData] = React.useState({ goal_list: [] })
  const [showSummary, setShowSummary] = React.useState([]);
  const [cycleDate, setCycleDate] = React.useState({});
  const [dataFeedback, setDataFeedback] = React.useState({});
  const [weightObject, setWeightObject] = React.useState({
    chart: {
      type: 'bar',
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false
      },
      offsetX: 0,
      offsetY: 20,
    },
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: -20,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%"
      },
    },
    dataLabels: {
      enabled: false
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: ['Category Ratio'],
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      },
    },
    yaxis: {
      show: false,
    },
    tooltip: {
      enabled: true,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      style: {
        fontSize: '16px',
        fontFamily: "Kanit",
        fontWeight: 300,
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName + ":",
        },
        style: {
          fontSize: '16px',
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        formatter: function (val) {
          return val;
        },
      },
      marker: {
        show: true,
      },
      items: {
        display: "flex",
      },
    },
    fill: {
      opacity: 1
    },
    legend: {
      show: false,
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 10,
      formatter: function (val, opts) {
        return val;
      }
    },
  })
  const [weightSeries, setWeightSeries] = React.useState([])
  const [categoryRatio, setCategoryRatio] = React.useState([])
  const [ratio, setRatio] = React.useState(0)
  const [goalListTotal, setGoalListTotal] = React.useState(0)
  const [question, setQuestion] = React.useState([]);
  const [statusSave, setStatusSave] = React.useState(false);
  const [confirmSubmit, setConfirmSubmit] = React.useState(false);
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
  const [openConfirmRejectPerformanceEvaliation, setOpenConfirmRejectPerformanceEvaliation] = React.useState(false);
  const [isSuccessRejectDialogOpen, openSuccessRejectDialog] = React.useState(false);
  const [allowApprove, setAllowApprove] = React.useState(true);

  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl2(null);
  };
  const open = Boolean(anchorEl2);
  const id = open ? 'simple-popover' : undefined;
  const [checkbox, setCheckbox] = React.useState([true, true, true, true, true, true, false]);
  const [filterCheckbox, setFilterCheckbox] = React.useState({
    selectAll: false,
    draft: true,
    new: true,
    update: true,
    pending: true,
    approved: true,
    pendingDelete: true,
    inActive: false,
  })
  const goto = (route, data) => {
    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const handleCheckbox = (data) => {
    let tmp = [...checkbox]
    let filterCheck = { ...filterCheckbox }
    if (data === "all") {
      if (checkboxStatus === "indeterminate") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      } else if (checkboxStatus === "all") {
        tmp = tmp.map(item => item = false)
        filterCheck.selectAll = false
        filterCheck.approved = false
        filterCheck.draft = false
        filterCheck.inActive = false
        filterCheck.new = false
        filterCheck.pending = false
        filterCheck.pendingDelete = false
        filterCheck.update = false
      } else if (checkboxStatus === "none") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      }
    } else if (data === "draft") {
      tmp[0] = !tmp[0]
      filterCheck.draft = tmp[0]
    } else if (data === "new") {
      tmp[1] = !tmp[1]
      filterCheck.new = tmp[1]
    } else if (data === "update") {
      tmp[2] = !tmp[2]
      filterCheck.update = tmp[2]
    } else if (data === "pending") {
      tmp[3] = !tmp[3]
      filterCheck.pending = tmp[3]
    } else if (data === "approved") {
      tmp[4] = !tmp[4]
      filterCheck.approved = tmp[4]
    } else if (data === "pending_delete") {
      tmp[5] = !tmp[5]
      filterCheck.pendingDelete = tmp[5]
    } else if (data === "inactive") {
      tmp[6] = !tmp[6]
      filterCheck.inactive = tmp[6]
    }
    setCheckbox(tmp);
    setFilterCheckbox(filterCheck)
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete') {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : Util.upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }

  const [goalAssignSerial, setGoalAssingSerial] = React.useState("")
  const setInitData = (value) => {
    let data = value;
    // set goal data
    const kpiForm = data?.my_goal?.kpi_form?.form_evaluate_data[0] ?? null;
    const formGoalAssign = kpiForm?.serial_goal_assign ?? null;
    let summaryExpand = []
    setGoalAssingSerial(formGoalAssign)
    if (kpiForm) {
      const { goal_list } = kpiForm.approval_summary

      let allow_approve = true
      //if (data?.workflow?.workflow_detail?.requester?.workflow_type !== 'cancel') {
      for (const g of goal_list) {
        if (allow_approve) allow_approve = (g.weight === 100 || g.weight === '100')
      }
      //}

      setAllowApprove(allow_approve)

      setApprovalData(kpiForm.approval_summary)
      // set default expand
      kpiForm?.approval_summary?.goal_list?.forEach((item, index) => {
        summaryExpand.push(index)
      })
      setShowSummary(summaryExpand)
      setCategoryRatio(kpiForm.goal_category_evaluate_ratio)
      setRatio(kpiForm.ratio)
      setGoalListTotal(kpiForm.my_goal_list.total)

      var colorWeight = [];
      var weightObjectData = { ...weightObject }
      weightObjectData.colors = colorWeight;
      const weightChart = kpiForm.goal_category_evaluate_ratio.map((item) => {
        colorWeight.push(item.color)
        return {
          name: item.name,
          data: [parseInt(item.weight)]
        }
      })
      setWeightObject(weightObjectData)
      setWeightSeries(weightChart)
    }
    if (kpiForm?.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status == undefined || kpiForm?.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status == null ||
      Object.keys(kpiForm.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status).length == 0) {
      var mockupProgress = {
        code: "not_started",
        color: "{\"font\": \"#DADADA\", \"background\": \"#FFFFFF\"}",
        is_default: true,
        name: "Not Started",
        seq: 1,
        serial: "bfaeaf1f-f5ad-4ddb-b02d-624f05d16da0"
      }
      mockupProgress.color = JSON.parse(mockupProgress.color)
      setGoalProgressMockup(mockupProgress)
    }
    let requestLogs = data.request_logs ?? [];
    // convert kpi_form cycle date
    let startAt = data?.my_goal?.kpi_form?.start_at ?? ""
    let endAt = data?.my_goal?.kpi_form?.end_at ?? ""
    if (startAt !== "") {
      let splitStartAt = startAt.split("/")
      startAt = splitStartAt[1] + "/" + splitStartAt[0] + "/" + splitStartAt[2]
    }
    if (endAt !== "") {
      let splitEndAt = endAt.split("/")
      endAt = splitEndAt[1] + "/" + splitEndAt[0] + "/" + splitEndAt[2]
    }
    setCycleDate({
      start_at: startAt,
      end_at: endAt
    })

    setRequestLogsData(requestLogs);
    // set workflow
    formatWorkflowData(data)
  };

  useEffect(() => {
    if (params.serial ?? false) {
      if (params?.feedback === "feedback") {
        loadFeedback()
      } else {
        dispatch(getInboxDetail(params.serial)).then((resp) => {
          setInitData(resp)
        });
      }
    } else {
      navigate(`/kpi/home`, { replace: false });
    }
  }, []);

  // chart
  let chartOptions = {
    type: "bar",
    color: "#939393",
    series: [],
    options: {
      unit: "คะแนน",
      chart: {
        type: "bar",
        stacked: true,
        stackType: "100%",
        toolbar: {
          show: false,
        },
        offsetX: 0,
        offsetY: 0,
        redrawOnWindowResize: true,
        redrawOnParentResize: true,
        width: "100%",
      },
      colors: [
        cssVariables.barChart.blue["200"],
        cssVariables.barChart.green["200"],
        cssVariables.barChart.orange["300"],
        cssVariables.barChart.orange["200"],
      ],
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 5,
          barHeight: "100%",
          colors: {
            ranges: [
              {
                from: 0,
                to: 0,
                color: "#F0F0F0",
              },
            ],
            backgroundBarColors: ["#F0F0F0"],
            backgroundBarOpacity: 1,
            backgroundBarRadius: 0,
          },
        },
      },
      grid: {
        show: false,
        padding: {
          top: -50,
          right: 0,
          bottom: -10,
          left: -20,
        },
      },
      stroke: {
        width: 0,
        colors: ["#fff"],
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        x: {
          show: false,
        },
        y: {
          formatter: function (val) {
            return val + " คะแนน";
          },
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
        position: "bottom",
        horizontalAlign: "left",
        offsetX: -33,
        offsetY: -55,
        formatter: function (val, opts) {
          const roundToHundred = (arr) => {
            let output = [];
            let acc = 0;
            for (let i = 0; i < arr.length; i++) {
              let roundedCur = Math.round(arr[i][0]);
              const currentAcc = acc;
              if (acc == 0) {
                output.push(roundedCur);
                acc += arr[i][0];
                continue;
              }
              acc += arr[i][0];
              output.push(Math.round(acc) - Math.round(currentAcc));
            }
            return output;
          };
          let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
          return (
            "<span class='fs-12px ml-2'>" +
            (val ? val : "-") +
            ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
            (opts.w.globals.series[opts.seriesIndex]
              ? opts.w.globals.series[opts.seriesIndex]
              : 0) +
            " (" +
            (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) +
            "%)" +
            "</span>"
          );
        },
      },
    },
  };
  // data for show
  // const currentData = useMemo(() => {
  //   return inboxDetail
  // }, [inboxDetail]);

  const loadFeedback = (val) => {
    myFeedback.getFeedbackInbox(params.serial).then((res) => {
      setQuestion(Util.formatData(res?.data?.feedback_question, []))
      let data = { workflow: { workflow_detail: Util.formatData(res?.data?.worfklow, {}) } }
      setDataFeedback(Util.formatData(res?.data, {}))
      formatWorkflowData(data)
    });
    openSuccessAddDialog(false)
  }

  const handleSetExpandSummary = (val) => {
    let tmpSum = [...showSummary]
    if (tmpSum.includes(val)) {
      tmpSum = tmpSum.filter(sum => sum !== val)
    } else {
      tmpSum.push(val)
    }
    setShowSummary(tmpSum)
  }

  const [criteriaScore, setCriteriaScore] = React.useState({});
  const calCriteriaScore = (formular) => {
    let data = { ...criteriaScore };
    return eval(formular);
  };
  // update chart
  const [chart, setChart] = React.useState(chartOptions);
  const [chartInfo, setChartInfo] = React.useState({
    accumulate: 0,
    total: 0,
    min: 0,
  });
  const ratioData = (oData, planning) => {
    let result = {
      chartData: [],
      accumulate: 0,
      total: 0,
      min: 0,
    };
    let tmpArray = [];
    let criteriaScore = {};
    if ((planning.planning ?? false) && (planning.ratio_data ?? false)) {
      for (let i = 0; i < planning.planning.length; i++) {
        for (let j = 0; j < planning.ratio_data.length; j++) {
          if (
            planning.planning[i].serial == Object.keys(planning.ratio_data[j])
          ) {
            let score = Number(
              planning.planning[i].is_accumulate === "y"
                ? Number(planning.planning[i].total_score) +
                Number(planning.planning[i].accumulate_use)
                : Number(planning.planning[i].total_score)
            );
            tmpArray.push({
              name: planning.planning[i].description,
              data: [score],
              seq: planning.planning[i].seq,
              code: planning.planning[i].code,
            });
            criteriaScore[planning.planning[i].code] = score;
            result.total = result.total + score; //คะแนนรวมปัจจุบัน
            result.min = Number(
              planning.ratio_data[j][planning.planning[i].serial]
                .criterion_score
            );
            if (planning.planning[i].is_accumulate === "y") {
              result.accumulate =
                result.accumulate + Number(planning.planning[i].accumulate_use); //คะแนนสะสมที่ใช้
            }
          }
        }
      }
    }
    setCriteriaScore(criteriaScore);
    result.chartData = tmpArray.sort((a, b) => a.seq - b.seq);
    return result;
  };
  const [checkboxStatus, setCheckboxStatus] = React.useState("all");

  const [workflow, setWorkflow] = React.useState("");
  const formatWorkflowData = (data) => {
    let tmpArray = []
    const workflow = data?.workflow?.workflow_detail ?? false
    if (workflow) {
      let requester = workflow.requester ?? false;
      let approver = workflow.approver ?? false;
      if (requester) {
        let obj = {
          seq: 0,
          mark: "requester",
          proxy: requester.proxy ?? "-",
          position: t("inbox.label.requester"),
          fullname: requester.employee.name ?? "-",
          fullname_en: requester.employee.name_en ?? "-",
          fullname_th: requester.employee.name_th ?? "-",
          employee_position: requester.employee.position ?? "-",
          date: requester?.employee?.date?.Time ?? "",
          status: requester.status ?? "",
          status_name: requester.status_name,
          type: requester.workflow_type,
          profileImage: requester?.employee?.photo ?? "",
          active: true,
          employeeStatus: requester?.employee?.status
            ? requester.employee.status == "active"
              ? 1
              : 2
            : 2,
          comment: requester.employee.remark ?? "",
          stepStatus:
            requester.status === "cancel"
              ? "default"
              : requester.workflow_type === "cancel" ||
                requester.workflow_type === "cancel_pending" ||
                requester.workflow_type === "cancel_cancel"
                ? "rejected"
                : requester.workflow_type === "approve"
                  ? "completed"
                  : "default",
        }

        if (requester?.submitted_by && requester?.submitted_by?.name) {
          obj.submitted_by = {
            fullname_en: requester.submitted_by?.name_en ?? "-",
            fullname_th: requester.submitted_by?.name_th ?? "-",
          }
        }

        tmpArray.push(obj)
      }

      if (approver) {
        for (const [key, value] of Object.entries(approver)) {
          let stepStatus = "inprogress";
          let isNeed = false;
          let obj = {
            seq: value[0].employee.seq ?? key,
            mark: "approver",
            proxy: value[0].proxy ?? "-",
            position: params?.feedback === "feedback" ? t('label.feedbackGiver') : value[0].employee.position ?? "-",
            employee: [],
            // active: value[0].complete || value[0].is_current ? true : false,
            active: true,
            type: value[0].workflow_type,
          };
          //console.log(value, 963);
          value.forEach((item) => {
            obj.employee.push({
              fullname: item.employee.name ?? "-",
              fullname_en: item.employee.name_en ?? "-",
              fullname_th: item.employee.name_th ?? "-",
              employee_position: item.employee.position ?? "-",
              date: item?.employee?.date ?? "",
              status: item.is_current
                ? item.status
                : item.status !== "wait"
                  ? item.status
                  : "",
              status_name: item.status_name,
              profileImage: item?.employee?.photo ?? "",
              employeeStatus: item?.employee?.status
                ? item.employee.status == "active"
                  ? 1
                  : 2
                : 2,
              // comment: "ควรเพิ่มในส่วนของงานที่ตรงกับยุทธ ศาสตร์มากกว่านี้นะคะ ในแผนภาระงาน ควรเพิ่มในส่วนของงานที่ตรงกับยุทธ ศาสตร์มากกว่านี้นะคะ ในแผนภาระงาน ควรเพิ่มในส่วนของงานที่ตรงกับยุทธ ศาสตร์มากกว่านี้นะคะ ในแผนภาระงาน ควรเพิ่มในส่วนของงานที่ตรงกับยุทธ ศาสตร์มากกว่านี้นะคะ ในแผนภาระงาน"
              comment: item.employee.remark ?? "",
              proxy: item.proxy ?? "-",
            });
            isNeed = item.need_all;
            if (requester.status === "cancel") {
              stepStatus = "default";
            } else {
              if (item.complete) {
                stepStatus = "completed";
                if (item.status === "reject") {
                  stepStatus = "rejected";
                }
              } else {
                if (item.status === "reject") {
                  stepStatus = "rejected";
                } else if (item.status === "approve") {
                  stepStatus = "completed";
                } else if (item.status === "") {
                  stepStatus = "default"
                }
              }

            }
          });
          obj.stepStatus = stepStatus
          tmpArray.push(obj)
        }
      }
    }
    setWorkflow(tmpArray)
  }

  const [requestLogsData, setRequestLogsData] = React.useState([]);
  const [apexChartWidth, setApexChartWidth] = React.useState("0px");

  useEffect(() => {
    setInitData(inboxDetail);
  }, [inboxDetail]);

  const [openApproveConfirmDialog, setApproveConfirmDialog] =
    React.useState(false);
  const handleOpenApproveConfirmDialog = (value) => {
    setApproveConfirmDialog(true);
  };
  const handleCloseApproveConfirmDialog = (value) => {
    setApproveConfirmDialog(false);
  };
  const [openRejectConfirmDialog, setRejectConfirmDialog] =
    React.useState(false);
  const handleOpenRejectConfirmDialog = (value) => {
    setRejectConfirmDialog(true);
  };
  const handleCloseRejectConfirmDialog = (value) => {
    setRejectConfirmDialog(false);
  };
  const [openCancelConfirmDialog, setCancelConfirmDialog] =
    React.useState(false);
  const handleOpenCancelConfirmDialog = (value) => {
    setCancelConfirmDialog(true);
  };
  const handleCloseCancelConfirmDialog = (value) => {
    setCancelConfirmDialog(false);
  };
  const [openCancelPendingConfirmDialog, setCancelPendingConfirmDialog] =
    React.useState(false);
  const handleOpenCancelPendingConfirmDialog = (value) => {
    setCancelPendingConfirmDialog(true);
  };
  const handleCloseCancelPendingConfirmDialog = (value) => {
    setCancelPendingConfirmDialog(false);
  };

  const [openCancelCancelConfirmDialog, setCancelCancelConfirmDialog] =
    React.useState(false);
  const handleOpenCancelCancelConfirmDialog = (value) => {
    setCancelCancelConfirmDialog(true);
  };
  const handleCloseCancelCancelConfirmDialog = (value) => {
    setCancelCancelConfirmDialog(false);
  };

  const [messageSuccess, setMessageSuccess] = React.useState("");
  const [failMessage, setMessageFail] = React.useState("");

  const handleApproval = (value) => {
    let approveData = {
      kpi_workflow_assign_id: inboxDetail?.workflow_assign ?? "",
      remark: value.description,
    };
    dispatch(postWorkflowSubmit(approveData))
      .then(() => {
        dispatch(getInboxDetail(params.serial));
        setApproveConfirmDialog(false);
        setMessageSuccess(
          t("inbox.label.dialog.approvalSuccess")
        );
        handleOpenSucceedMessageDialog(true);
      })
      .catch(() => {
        setApproveConfirmDialog(false);
        setMessageFail(
          t("inbox.label.dialog.approvalFail")
        );
        handleOpenFailedMessageDialog(true);
        // dispatch(getInboxDetail(params.serial))
      });
  }
  const handleReject = (value) => {
    let rejectData = {
      kpi_workflow_assign_id: inboxDetail?.workflow_assign ?? "",
      remark: value.description,
    };
    dispatch(postWorkflowReject(rejectData))
      .then(() => {
        dispatch(getInboxDetail(params.serial));
        setRejectConfirmDialog(false);
        setMessageSuccess(
          t("inbox.label.dialog.rejectSuccess")
        );
        handleOpenSucceedMessageDialog(true);
      })
      .catch(() => {
        setRejectConfirmDialog(false);
        setMessageFail(
          t("inbox.label.dialog.rejectFail")
        );
        handleOpenFailedMessageDialog(true);
        // dispatch(getInboxDetail(params.serial))
      });
  };
  const handleCancel = (value) => {
    let cancelData = {
      kpi_workflow_id: inboxDetail?.workflow?.workflow_id ?? "",
      remark: value.description,
    };
    dispatch(postWorkflowCancel(cancelData))
      .then(() => {
        dispatch(getInboxDetail(params.serial));
        setCancelConfirmDialog(false);
        setMessageSuccess(t("inbox.label.dialog.cancelSuccess"));
        handleOpenSucceedMessageDialog(true);
      })
      .catch(() => {
        setCancelConfirmDialog(false);
        setMessageFail(
          t("inbox.label.dialog.cancelFail")
        );
        handleOpenFailedMessageDialog(true);
        // dispatch(getInboxDetail(params.serial))
      });
  };
  const handleCancelCancel = (value) => {
    let cancelData = {
      kpi_workflow_id: inboxDetail?.workflow?.workflow_id ?? "",
      remark: value.description,
    };
    dispatch(postWorkflowCancel(cancelData))
      .then(() => {
        dispatch(getInboxDetail(params.serial));
        setCancelConfirmDialog(false);
        setMessageSuccess(t("inbox.label.dialog.cancelCancelSuccess"));
        handleOpenSucceedMessageDialog(true);
      })
      .catch(() => {
        setCancelConfirmDialog(false);
        setMessageFail(
          t("inbox.label.dialog.cancelCancelFail")
        );
        handleOpenFailedMessageDialog(true);
        // dispatch(getInboxDetail(params.serial))
      });
  };
  const handlePendingCancel = (value) => {
    let requestData = {
      kpi_workflow_assign_id: inboxDetail?.workflow_assign ?? "",
      remark: value.description,
    };
    dispatch(postWorkflowRequest(requestData))
      .then(() => {
        dispatch(getInboxDetail(params.serial));
        setCancelPendingConfirmDialog(false);
        setMessageSuccess(
          t("inbox.label.dialog.pendingCancelSuccess")
        );
        handleOpenSucceedMessageDialog(true);
      })
      .catch(() => {
        setCancelPendingConfirmDialog(false);
        setMessageFail(
          t("inbox.label.dialog.pendingCancelFail")
        );
        handleOpenFailedMessageDialog(true);
      });
  };
  // message dialog
  const [openSucceedMessageDialog, setSucceedMessageDialog] =
    React.useState(false);
  const handleOpenSucceedMessageDialog = (value) => {
    setSucceedMessageDialog(true);
  };
  const handleCloseSucceedMessageDialog = (value) => {
    setSucceedMessageDialog(false);
    navigate(`/kpi/inbox`, { replace: false });
  };
  const [openFailedMessageDialog, setFailedMessageDialog] =
    React.useState(false);
  const handleOpenFailedMessageDialog = (value) => {
    setFailedMessageDialog(true);
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
    navigate(`/kpi/inbox`, { replace: false });
  };
  // read more dialog
  // handleOpenReadMoreDialog
  const [readMoreComment, setReadMoreComment] = React.useState("");
  const [openReadMoreDialog, setReadMoreDialog] = React.useState(false);
  const handleOpenReadMoreDialog = (value) => {
    setReadMoreComment(value);
    setReadMoreDialog(true);
  };
  const handleCloseReadMoreDialog = (value) => {
    setReadMoreDialog(false);
  };

  const classes = useStyles();

  const styles = {
    greenBadge: {
      background: "rgb(186 217 87 / 15%)",
      color: "#93AC41",
      padding: "2px 5px",
      marginTop: "21px",
      width: "fit-content",
    },
    blockGrid: {
      padding: "38px 0 0 0",
    },
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [toggleSteppers, setToggleSteppers] = React.useState(true);
  const [requestLogToggle, setRequestLogToggle] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOption = Boolean(anchorEl);

  useEffect(() => {
    if (params?.feedback !== "feedback") {
      let apex = document.getElementById("apexchart");
      setApexChartWidth(apex.parentElement.clientWidth + "px");
    }
  }, [toggleSteppers]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleGoToMyGoalDetail = (serial) => {
    if (serial !== "") {
      // navigate(`/kpi/mygoal/${serial}`, { replace: false });
      window.open(`/kpi/mygoal/${serial}`, "_blank")
    }
  };
  const handleSteppersTransition = () => {
    setToggleSteppers(!toggleSteppers);
  };

  const handleToggleRequestLog = () => {
    setRequestLogToggle(!requestLogToggle);
  };

  const inboxType = location.pathname.split("/");
  const [serialDetail, setSerialDetail] = React.useState(null)

  const handleClick = (event, serial) => {
    setSerialDetail(serial)
    setAnchorEl(event.currentTarget);
  };

  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})

  let onChange = (e, index, type) => {
    if (Util.formatData(question, []).length > 0) {
      let data = JSON.parse(JSON.stringify(question))
      data[index][type] = type === "emotion" ? data[index][type] === e ? "" : e : e.target.value
      setQuestion(data)
    }
  }
  let doConfirmSubmit = () => {
    setConfirmSubmit(false)
    myFeedback.submitFeedback({
      "serial": Util.formatData(dataFeedback?.feedback?.serial, ""),
      "feedback_question": question
    }).then((rs) => {
      openSuccessAddDialog(true)
    })
  }

  let openDialogSubmit = () => {
    if (statusSave === false) {
      setStatusSave(true)
    }
    if (checkFeedback() === true) {
      setConfirmSubmit(true)
    }
  }

  let checkFeedback = () => {
    let check = false
    let mapFeedback = Util.formatData(question, []).filter((rs) => Util.formatData(rs?.comment, false) === false && Util.formatData(rs?.emotion, false) === false)
    if (mapFeedback.length === 0) {
      check = true
    }
    return check
  }

  let actionReject = (data) => {
    setOpenConfirmRejectPerformanceEvaliation(false)
    myFeedback.rejectFeedback({
      serial: Util.formatData(dataFeedback?.feedback?.serial, ""),
      remark: Util.formatData(data?.description, "")
    }).then(
      (response) => {
        openSuccessRejectDialog(true)
      },
    ).catch(() => {
    })
  }

  const editGoal = (goal_serial) => {
    navigate('/kpi/mygoal/' + goal_serial, { replace: false })
  }

  return (
    <>
      <Helmet>
        <title>Inbox | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container mt={1} mb={1}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span
                style={{ color: "#5DA196", cursor: "pointer" }}
                onClick={() => navigate("/kpi/home")}
              >
                {t("label.home")}
              </span>{" "}
              /{" "}
              <span
                style={{ color: "#5DA196", cursor: "pointer" }}
                onClick={() => navigate("/kpi/inbox")}
              >
                {t("label.inbox")}
              </span>{" "}
              /{" "}
              <span style={{ color: "#A3A3A3" }}>
                {" "}
                {inboxType[3] === "received" ? t("inbox.label.received") : t("inbox.label.sent")}{" "}
              </span>
            </Typography>
          </Grid>
          <Grid container spacing={2} mt={1} mb={0}>
            <Grid item>
              <Typography color="#404349" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {inboxType[3] === "received" ? t("inbox.label.received") : t("inbox.label.sent")}
              </Typography>
            </Grid>
            <Grid item xs="auto" ml="auto">
              <Box display="flex" sx={{ width: "fit-content" }}>
                {(inboxDetail?.allow_evaluator_edit_goal && false) &&
                  <React.Fragment>
                    <Button
                      onClick={() =>
                        handleGoToMyGoalDetail(
                          goalAssignSerial ?? ""
                        )
                      }
                      startIcon={<EditIcon />} fullWidth
                      className="btn-large"
                      sx={{ marginRight: 1, textTransform: "none", borderColor: "#5DA196", whiteSpace: "nowrap" }}
                      variant="outlined" >{t("label.editGoal")}</Button>
                  </React.Fragment>
                }

                {inboxDetail?.action ?? false ? (
                  inboxDetail.action.map((item) => {
                    if (item === "reject") {
                      return (
                        <React.Fragment>
                          <Button
                            color="red"
                            variant="contained"
                            fullWidth
                            startIcon={<MarkIcon />}
                            className="btn-large"
                            sx={{ marginRight: 1, textTransform: "none" }}
                            onClick={handleOpenRejectConfirmDialog}
                          >
                            {t("inbox.label.reject")}
                          </Button>
                        </React.Fragment>
                      );
                    } else if (item === "verify") {
                      return (
                        <React.Fragment>
                          <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            startIcon={<CheckIcon />}
                            className="btn-large"
                            sx={{ textTransform: "none" }}
                            onClick={handleOpenApproveConfirmDialog}
                          >
                            {t("inbox.label.verify")}
                          </Button>
                        </React.Fragment>
                      );
                    } else if (item === "approve") {
                      return (
                        <React.Fragment>
                          <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            startIcon={<CheckIcon />}
                            className="btn-large"
                            sx={{ textTransform: "none" }}
                            onClick={handleOpenApproveConfirmDialog}
                            disabled={!allowApprove}
                          >
                            {t("inbox.label.approve")}
                          </Button>
                        </React.Fragment>
                      );
                    } else if (item === "cancel") {
                      // return (
                      //   <React.Fragment>
                      //     <Button
                      //       color="red"
                      //       variant="contained"
                      //       fullWidth
                      //       startIcon={<MarkIcon />}
                      //       className="btn-large"
                      //       sx={{ textTransform: "none"}}
                      //       onClick={handleOpenCancelConfirmDialog}
                      //     >
                      //       {t("inbox.label.withdraw")}
                      //     </Button>
                      //   </React.Fragment>
                      // );
                    } else if (item === "pending_cancel") {
                      // return (
                      //   <React.Fragment>
                      //     <Button
                      //       color="red"
                      //       variant="contained"
                      //       fullWidth
                      //       startIcon={<MarkIcon />}
                      //       className="btn-large"
                      //       sx={{ textTransform: "none"}}
                      //       onClick={handleOpenCancelPendingConfirmDialog}
                      //     >
                      //       {t("inbox.label.cancelPending")}
                      //     </Button>
                      //   </React.Fragment>
                      // ); 
                    } else if (item === "cancel_cancel") {
                      return (
                        <React.Fragment>
                          <Button
                            color="red"
                            variant="outlined"
                            fullWidth
                            startIcon={<CancelIcon />}
                            className="btn-large"
                            sx={{ textTransform: "none" }}
                            onClick={handleOpenCancelCancelConfirmDialog}
                          >
                            {t("inbox.label.cancelCancel")}
                          </Button>
                        </React.Fragment>
                      );
                    } else {
                      return <></>;
                    }
                  })
                ) : (
                  <></>
                )}
                {dataFeedback?.action?.can_reject === true && dataFeedback?.status === "wait" ?
                  <React.Fragment>
                    <Button
                      color="red"
                      variant="contained"
                      fullWidth
                      startIcon={<MarkIcon />}
                      className="btn-large"
                      sx={{ marginRight: 1, textTransform: "none" }}
                      onClick={e => setOpenConfirmRejectPerformanceEvaliation(true)}
                    >
                      {t("inbox.label.reject")}
                    </Button>
                  </React.Fragment>
                  :
                  null
                }
                {dataFeedback?.action?.can_submit === true && dataFeedback?.status === "wait" ?
                  <React.Fragment>
                    <Button
                      color="primary"
                      variant="contained"
                      fullWidth
                      startIcon={<SubmitIcon />}
                      className="btn-large"
                      sx={{ textTransform: "none" }}
                      onClick={e => openDialogSubmit()}
                    >
                      {t("label.submit")}
                    </Button>
                  </React.Fragment>
                  :
                  null
                }
              </Box>
            </Grid>

          </Grid>
          <Grid container spacing={2} mt={0} mb={2} wrap="nowrap">
            {/* left box - detail */}
            <Grid
              item
              xs={toggleSteppers ? 9 : true}
              sm={toggleSteppers ? 9 : true}
              md={toggleSteppers ? 9 : true}
              lg={toggleSteppers ? 9 : true}
            >
              {params?.feedback === "feedback" ?
                <StylePaper elevation={3}>
                  <Box display="flex" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", paddingBottom: "20px" }}>
                    <Box >
                      <Avatar src={Util.formatData(dataFeedback?.receiver?.photo, "")}
                        sx={{
                          cursor: "pointer",
                          width: 65,
                          height: 65,
                        }} />
                    </Box>
                    <Box width="calc(100% - 65px)" pl="20px" display="flex" justifyContent="space-between">
                      <Box >
                        <Typography pt="3px" color="#5DA196" fontSize={24} lineHeight="26.4px" fontWeight="600" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {language === "en-US" ?
                            dataFeedback?.receiver?.fullname_en ? dataFeedback?.receiver?.fullname_en : "-" :
                            dataFeedback?.receiver?.fullname_th ? dataFeedback?.receiver?.fullname_th : "-"
                          }
                        </Typography>
                        <Typography fontSize={18} lineHeight="27px" pt="5px">
                          {dataFeedback?.feedback?.type === "normal" ? t('feedback.label.myFeedback') : t('feedback.label.evaluationFeedback')}
                        </Typography>
                        {Util.formatData(dataFeedback?.requested_by, false) !== false ?
                          <Typography color="#AAAAAA" fontSize={14} lineHeight="21px" pt="7px">
                            {t('feedback.label.requestedBy')}: {dataFeedback?.requested_by}
                          </Typography>
                          :
                          null
                        }
                      </Box>
                      <Box >
                        <div
                          className={`${classes.statusBadge} ${dataFeedback?.status === "wait"
                            ? classes.pendingBg
                            : dataFeedback?.status === "complete" || dataFeedback?.status === "completed"
                              ? classes.approveBg
                              : dataFeedback?.status === "reject" ?
                                classes.rejectedBg
                                : ""
                            }`}
                          style={{ padding: "5px 10px" }}
                        >
                          <Typography
                            className={dataFeedback?.status === "wait"
                              ? classes.pendingText
                              : dataFeedback?.status === "complete" || dataFeedback?.status === "completed"
                                ? classes.approveText
                                : dataFeedback?.status === "reject" ?
                                  classes.rejectedText
                                  : ""
                            }
                            fontWeight={500}
                            fontSize={16}
                            lineHeight="23.92px"
                          >
                            {dataFeedback?.status === "wait" ? t('label.inProgress') : dataFeedback?.status === "complete" || dataFeedback?.status === "completed" ? t('label.completed') : dataFeedback?.status === "reject" ? t('label.status.rejected') : "-"}
                          </Typography>
                        </div>
                        <Typography color="#939393" fontSize={14} lineHeight="15.4px" pt="15px" textAlign="end">
                          {Util.dateDayTimeFormatAdmin(dataFeedback?.lastest_updated)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Paper
                    elevation={0}
                  >
                    <Box sx={{ display: "flex", }}   >
                      <Box sx={{ width: "100%" }} >
                        <Typography color="#404349" py="20px" fontSize={20} lineHeight="29.9px" fontWeight="500" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataFeedback?.feedback?.title}</Typography>
                        {dataFeedback?.feedback?.type === "goal" || dataFeedback?.feedback?.type === "competency" || dataFeedback?.feedback?.type === "probation" ?
                          <Box>
                            <Box display="flex">
                              <Box width="225px" pr="20px">
                                <Typography color="#A3A3A3" fontSize={18} lineHeight="26.91px">{dataFeedback?.feedback?.type === "probation" ? t('evaluation.probationName') : dataFeedback?.feedback?.type === "goal" ? t('evaluation.goalName') : dataFeedback?.feedback?.type === "competency" ? t('evaluation.competencyName') : ""}</Typography>
                              </Box>
                              <Box width="calc(100% - 225px)">
                                <Typography color="#404349" fontSize={18} lineHeight="26.91px" dangerouslySetInnerHTML={{ __html: dataFeedback?.feedback?.type === "probation" ? Util.formatData(dataFeedback?.feedback?.options?.probation?.name, "-") : dataFeedback?.feedback?.type === "goal" ? Util.formatData(dataFeedback?.feedback?.options?.goal?.name, "-") : dataFeedback?.feedback?.type === "competency" ? Util.formatData(dataFeedback?.feedback?.options?.competency?.name, "-") : "-" }}></Typography>
                              </Box>
                            </Box>
                            {dataFeedback?.feedback?.type !== "probation" ?
                              <Box display="flex" py="20px">
                                <Box width="225px" pr="20px">
                                  <Typography color="#A3A3A3" fontSize={18} lineHeight="26.91px">{dataFeedback?.feedback?.type === "probation" ? t('evaluation.probationDescription') : dataFeedback?.feedback?.type === "goal" ? t('evaluation.goalDescription') : dataFeedback?.feedback?.type === "competency" ? t('evaluation.competencyDescription') : ""}</Typography>
                                </Box>
                                <Box width="calc(100% - 225px)">
                                  <Typography color="#404349" fontSize={18} lineHeight="26.91px">{dataFeedback?.feedback?.type === "probation" ? Util.formatData(dataFeedback?.feedback?.options?.probation?.description, "-") : dataFeedback?.feedback?.type === "goal" ? Util.formatData(dataFeedback?.feedback?.options?.goal?.description, "-") : dataFeedback?.feedback?.type === "competency" ? Util.formatData(dataFeedback?.feedback?.options?.competency?.description, "-") : "-"}</Typography>
                                </Box>
                              </Box>
                              : null
                            }
                          </Box>
                          :
                          null
                        }
                        {Util.formatData(dataFeedback?.feedback_question, [].length > 0) ?
                          dataFeedback?.feedback_question.map((data, idx) =>
                            <Box>
                              {dataFeedback?.feedback?.type === "goal" || dataFeedback?.feedback?.type === "competency" || dataFeedback?.feedback?.type === "probation" ? null :
                                <Typography fontWeight="500" color="#5DA196" fontSize={14} lineHeight="20.93px" sx={{ width: "calc(100% - 15px)", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content" }} >Q{idx + 1}:<span style={{ "padding-left": "5px" }}>{data?.question}</span></Typography>
                              }
                              <Box pt="10px" pb="15px" pl={dataFeedback?.feedback?.type === "goal" || dataFeedback?.feedback?.type === "competency" || dataFeedback?.feedback?.type === "probation" ? "" : "18px"}>
                                <Box sx={{ display: "flex", width: "100%" }} >
                                  <Avatar
                                    src={dataFeedback?.giver?.photo}
                                    sx={{
                                      width: 30,
                                      height: 30,
                                    }}
                                  >
                                  </Avatar>
                                  {inboxType[3] === "received" && dataFeedback?.status === "wait" ?
                                    <Box pl="10px" width="calc(100% - 30px)">
                                      <Typography color="#888F9D" fontWeight="400" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataFeedback?.giver?.fullname}</Typography>
                                      <Box pt="5px" maxWidth="900px" sx={{ display: "flex", overflowX: "auto", justifyContent: "space-between" }}>
                                        {IconFeedback.map((rating, i) => (
                                          <BootstrapTooltip key={i} title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{rating.label}</span>} placement="top">
                                            <Box className={`${classes.boxIcon}`} sx={{ backgroundColor: question[idx]?.emotion === rating.id ? "#5DA196" : "", height: "60px", borderRadius: "100px" }} >
                                              <img width="60px" height="60px" src={rating?.icon} alt={rating?.label} style={{ display: "block", cursor: "pointer" }} onClick={e => onChange(rating?.id, idx, "emotion")} />
                                            </Box>
                                          </BootstrapTooltip>
                                        ))}
                                      </Box>
                                      <Box width="100% " sx={{ ".MuiFormControl-root": { "margin": "0" } }} pt="5px">
                                        <TextField
                                          error={statusSave && Util.formatData(question[idx].comment, false) === false && Util.formatData(question[idx].emotion, false) === false}
                                          fullWidth
                                          margin="normal"
                                          name="code"
                                          onChange={e => onChange(e, idx, "comment")}
                                          type="text"
                                          value={question[idx].comment}
                                          variant="outlined"
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                          multiline
                                          minRows={3}
                                          placeholder={t('label.fillYourFeedback')}
                                          classes={{ root: classes.input }}
                                          sx={{ ".MuiOutlinedInput-root": { color: "#404349", borderRadius: "10px", padding: "10px 15px" }, ".MuiOutlinedInput-notchedOutline": { border: "1px solid #E4E7EA" } }}
                                          inputProps={{
                                            sx: {
                                              "&::placeholder": {
                                                color: "#BEC2CB",
                                                fontWeight: "300",
                                                opacity: "1"
                                              }
                                            }
                                          }}
                                        />
                                        {statusSave && Util.formatData(question[idx].comment, false) === false && Util.formatData(question[idx].emotion, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.code')}</FormHelperText>) : <></>}
                                      </Box>
                                    </Box>
                                    :
                                    <Box pl="10px" width="calc(100% - 30px)">
                                      <Typography color="#888F9D" fontWeight="400" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataFeedback?.giver?.fullname}</Typography>
                                      {Util.formatData(data?.emotion, false) !== false ?
                                        <Box pt="5px">
                                          <BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{data?.emotion === "angry" ? t('feedback.label.angry') : data?.emotion === "bored" ? t('feedback.label.bored') : data?.emotion === "lazy" ? t('feedback.label.lazy') : data?.emotion === "worried" ? t('feedback.label.worried') : data?.emotion === "disappointed" ? t('feedback.label.disappointed') : data?.emotion === "accomplished" ? t('feedback.label.accomplished') : data?.emotion === "loved" ? t('feedback.label.loved') : data?.emotion === "joyful" ? t('feedback.label.joyful') : data?.emotion === "happy" ? t('feedback.label.happy') : data?.emotion === "excited" ? t('feedback.label.excited') : "-"}</span>} placement="top">
                                            <img width="60px" height="60px" src={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} alt={data?.emotion === "angry" ? angry : data?.emotion === "bored" ? bored : data?.emotion === "lazy" ? lazy : data?.emotion === "worried" ? worried : data?.emotion === "disappointed" ? disappointed : data?.emotion === "accomplished" ? accomplished : data?.emotion === "loved" ? loved : data?.emotion === "joyful" ? joyful : data?.emotion === "happy" ? happy : data?.emotion === "excited" ? excited : ""} />
                                          </BootstrapTooltip>
                                        </Box>
                                        :
                                        null
                                      }
                                      {Util.formatData(data?.comment, false) !== false ?
                                        <Box p="10px 15px" mt="5px" backgroundColor="#EFF6F4" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                                          <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" >{Util.formatData(data?.comment, "-")}</Typography>
                                        </Box>
                                        :
                                        null
                                      }

                                      {Util.formatData(data?.comment, false) === false && Util.formatData(data?.emotion, false) === false ?
                                        <Box p="10px 15px" mt="5px" backgroundColor="#F6F6F6" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                                          <Typography color="#888F9D" fontWeight="400" fontSize={16} lineHeight="23.92px" >{dataFeedback?.status === "reject" ? t('feedback.label.feedbackWasRejected') : t('feedback.label.waitingForFeedback')}</Typography>
                                        </Box>
                                        :
                                        null
                                      }
                                    </Box>
                                  }
                                </Box>
                              </Box>
                            </Box>
                          )
                          :
                          null
                        }
                      </Box>
                    </Box>
                  </Paper>
                </StylePaper>
                :
                <StylePaper elevation={3}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {inboxDetail?.employee?.photo ?? false ? (
                        <img
                          className={`${classes.profileContainer}`}
                          src={inboxDetail.employee.photo}
                          alt="profile"
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = personImg;
                          }}
                        />
                      ) : (
                        <Avatar className={`${classes.profileContainer}`} />
                      )}
                    </Grid>
                    <Grid item xs sm>
                      <Grid container py={1}>
                        <Grid item xs sm>
                          <Grid container>
                            <Grid item display="flex">
                              <Typography
                                variant="h3"
                                color="primary"
                                sx={{ marginTop: "auto" }}
                              >
                                {language === "en-US" ?
                                  inboxDetail?.employee?.fullname_en ? inboxDetail.employee.fullname_en : "-" :
                                  inboxDetail?.employee?.fullname_th ? inboxDetail.employee.fullname_th : "-"
                                }
                              </Typography>
                            </Grid>
                            <Grid item ml="auto" xs="auto" sm="auto">
                              <div
                                className={`${classes.statusBadge} ${inboxDetail?.workflow?.status === "ระหว่างการแก้ไข" || inboxDetail?.workflow?.status === "draft" || inboxDetail?.workflow?.status === "ระหว่างดำเนินการ"
                                  ? classes.draftBg
                                  : inboxDetail?.workflow?.status === "ระหว่างการอนุมัติ" || inboxDetail?.workflow?.status === "pending"
                                    ? classes.pendingBg
                                    : inboxDetail?.workflow?.status === "อนุมัติเสร็จสิ้น" || inboxDetail?.workflow?.status === "approve" || inboxDetail?.workflow?.status === "approved" || inboxDetail?.workflow?.status === "complete" || inboxDetail?.workflow?.status === "completed"
                                      ? classes.approveBg
                                      : inboxDetail?.workflow?.status === "ปฏิเสธ" || inboxDetail?.workflow?.status === "reject" || inboxDetail?.workflow?.status === "rejected"
                                        ? classes.rejectedBg
                                        : inboxDetail?.workflow?.status === "ยกเลิกเสร็จสิ้น" || inboxDetail?.workflow?.status === "cancel"
                                          ? classes.cancelBg
                                          : classes.cancelPendingBg
                                  }`}
                              >
                                <Typography
                                  className={
                                    inboxDetail?.workflow?.status === "ระหว่างการแก้ไข" || inboxDetail?.workflow?.status === "ระหว่างดำเนินการ" || inboxDetail?.workflow?.status === "draft"
                                      ? classes.draftText
                                      : inboxDetail?.workflow
                                        ?.status ===
                                        "ระหว่างการอนุมัติ" || inboxDetail?.workflow?.status === "pending"
                                        ? classes.pendingText
                                        : inboxDetail?.workflow
                                          ?.status ===
                                          "อนุมัติเสร็จสิ้น" || inboxDetail?.workflow?.status === "approve" || inboxDetail?.workflow?.status === "approved" || inboxDetail?.workflow?.status === "complete" || inboxDetail?.workflow?.status === "completed"
                                          ? classes.approveText
                                          : inboxDetail?.workflow
                                            ?.status === "ปฏิเสธ" || inboxDetail?.workflow?.status === "reject" || inboxDetail?.workflow?.status === "rejected"
                                            ? classes.rejectedText
                                            : inboxDetail?.workflow
                                              ?.status ===
                                              "ยกเลิกเสร็จสิ้น" || inboxDetail?.workflow?.status === "cancel"
                                              ? classes.cancelText
                                              : classes.cancelPendingText
                                  }
                                  fontWeight={500}
                                  variant="h6"
                                >
                                  {Util.upperFirstWord(inboxDetail?.workflow
                                    ?.status_name) ?? "-"}
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item xs="auto" sm="auto" md="auto" ml={3}>
                              <Button
                                color="black"
                                variant="outlined"
                                fullWidth
                                startIcon={<DocIcon />}
                                className="btn-large"
                                onClick={() =>
                                  handleGoToMyGoalDetail(
                                    goalAssignSerial ?? ""
                                  )
                                }
                              >
                                <Typography variant="h6" color="black" sx={{ textTransform: "none" }}>
                                  {t("inbox.label.seeDetails")}
                                </Typography>
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid container mt={0}>
                            <Grid item xs="auto" sm="auto">
                              <Typography variant="label">
                                {t("inbox.label.myGoal")}
                              </Typography>
                            </Grid>
                            {/* <Grid item ml="auto">
                            <Typography
                              variant="sub_label"
                              color="black"
                              fontSize={14}
                            >
                              { dateDayTimeFormat(inboxDetail?.rb_pa_data?.[0]?.start) ?? "-" }
                            </Typography>
                          </Grid> */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {requestLogsData.length > 0 ? (
                    <Grid container mt={2} mb={1}>
                      <Grid item xs md lg>
                        <Box
                          sx={{
                            border: `1px solid ${requestLogsData[0].status === "request" ||
                              requestLogsData[0].status === "verified" ||
                              requestLogsData[0].status === "approved"
                              ? "#5DA196"
                              : "#CC6058"
                              }`,
                            borderRadius: "10px",
                          }}
                        >
                          <Collapse
                            in={requestLogToggle}
                            collapsedSize={45}
                            sx={{ padding: "10px", position: "relative" }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                borderLeft: `0.5px dashed #BBBEBE`,
                                top: "50%",
                                transform: "translate(-50%, -50%)",
                                height: "calc(100% - 40px)",
                                marginLeft: "6.5px",
                                zIndex: "0",
                              }}
                            ></div>
                            <Grid container spacing={2}>
                              <Grid
                                item
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <div
                                  style={{
                                    background: `${requestLogsData[0].status === "request" ||
                                      requestLogsData[0].status === "verified" ||
                                      requestLogsData[0].status === "approved"
                                      ? "#5DA196"
                                      : "#CC6058"
                                      }`,
                                    borderRadius: "50%",
                                    width: "12px",
                                    height: "12px",
                                    zIndex: "1",
                                  }}
                                ></div>
                              </Grid>
                              <Grid
                                item
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Typography
                                  color={`${requestLogsData[0].status === "request" ||
                                    requestLogsData[0].status === "verified" ||
                                    requestLogsData[0].status === "approved"
                                    ? "#5DA196"
                                    : "#CC6058"
                                    }`}
                                >
                                  {t("label.request.status")} :{" "}
                                  {t(
                                    `label.status.requestLog.${requestLogsData[0].status}`
                                  )}{" "}
                                  (
                                  {Util.dateDayTimeFormat(
                                    requestLogsData[0].created_at
                                  )}
                                  )
                                </Typography>
                              </Grid>
                              {requestLogsData.length > 1 ? (
                                <Grid
                                  item
                                  xs
                                  sm
                                  md
                                  lg
                                  sl
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="flex-end"
                                >
                                  <Box
                                    sx={{
                                      transform: requestLogToggle
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                      transition: "0.4s",
                                    }}
                                  >
                                    <DownArrowIcon
                                      onClick={handleToggleRequestLog}
                                      className="clickable"
                                    ></DownArrowIcon>
                                  </Box>
                                </Grid>
                              ) : (
                                <></>
                              )}
                            </Grid>
                            {requestLogsData.slice(1).map((item) => (
                              <Grid container spacing={2} mt={1}>
                                <Grid
                                  item
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <div
                                    style={{
                                      background: `${item.status === "request" ||
                                        item.status === "verified" ||
                                        item.status === "approved"
                                        ? "#5DA196"
                                        : "#CC6058"
                                        }`,
                                      borderRadius: "50%",
                                      width: "12px",
                                      height: "12px",
                                      zIndex: "1",
                                    }}
                                  ></div>
                                </Grid>
                                <Grid
                                  item
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Typography
                                    color={`${item.status === "request" ||
                                      item.status === "verified" ||
                                      item.status === "approved"
                                      ? "#5DA196"
                                      : "#CC6058"
                                      }`}
                                  >
                                    {t("label.request.status")} :{" "}
                                    {t(`label.status.requestLog.${item.status}`)}{" "}
                                    ({Util.dateDayTimeFormat(item.created_at)})
                                  </Typography>
                                </Grid>
                              </Grid>
                            ))}
                          </Collapse>
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid container mt={1}>
                    <Grid item xs sm md>
                      <Paper
                        elevation={0}
                        classes={{ root: classes.paperDetailContainer }}
                      >
                        <Grid container mb={1}>
                          <Grid item xs sm md>
                            <Typography variant="h3">
                              {t("inbox.label.myGoalSummary")}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container mt={2}>
                          <Grid item xs sm md>
                            <Card sx={{ width: "100%" }}>
                              <Box style={{ height: "100%" }}>
                                <CardContent>
                                  <Grid container spacing={0}>
                                    <Grid item sx={{ position: "relative" }} xs={12} sm={6} md={6} lg={6} xl={6}>
                                      <Grid container>
                                        <Grid item>
                                          <Typography variant="h4">
                                            {language === "en-US" ?
                                              inboxDetail?.goal_form?.name_en ? inboxDetail.goal_form.name_en : "-" :
                                              inboxDetail?.goal_form?.name_th ? inboxDetail.goal_form.name_th : "-"
                                            }
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container>
                                        <Grid item sx={{ display: "flex", alignItems: "center" }}>
                                          <CalendarIcon className={`${classes.calendarIcon}`} />
                                          <Typography sx={{ ml: 1 }}>
                                            {t("inbox.label.cycle")}: {Util.dateDayFormat(cycleDate?.start_at) ?? "N/A"} - {Util.dateDayFormat(cycleDate?.end_at) ?? "N/A"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container sx={{ position: "absolute", bottom: 0, flexFlow: "nowrap" }}>
                                        <Grid item mr={1}>
                                          <div
                                            className={`${classes.iconContainer} ${classes.blueBg}`}
                                          >
                                            <img
                                              src={planningImg}
                                              alt="bannerImage"
                                            />
                                          </div>
                                        </Grid>
                                        <Grid item display="flex" alignItems="center">
                                          <Typography
                                            variant="h3"
                                            sx={{
                                              color: cssVariables.color.blue,
                                            }}
                                          >
                                            {t("inbox.label.myGoal")}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item ml="auto" xs={4} sm={4} md={4}>
                                      <Grid container mb={1}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Typography variant="sub_label">
                                            {t("inbox.label.position")}:
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                          <Typography variant="sub_label_black">
                                            {inboxDetail?.employee?.position ?? "-"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container mb={1}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Typography variant="sub_label">
                                            {t("inbox.label.team")}:
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                          <Typography variant="sub_label_black">
                                            {inboxDetail?.employee?.organization ?? "-"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container mb={1}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Typography variant="sub_label">
                                            {t("inbox.label.employeeId")}:
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                          <Typography variant="sub_label_black">
                                            {inboxDetail?.employee?.code ?? "-"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Grid container mb={1}>
                                        <Grid item xs={6} sm={6} md={6}>
                                          <Typography variant="sub_label">
                                            {t("inbox.label.joinedDate")}:
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                          <Typography variant="sub_label_black">
                                            {inboxDetail?.employee?.joined_date ? Util.dateDayFormat(inboxDetail.employee.joined_date) : "-"}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </CardContent>
                              </Box>
                            </Card>
                          </Grid>
                        </Grid>
                        <Grid container spacing={4} mt={1}>
                          <Grid lg={12} xs={12} item>
                            <Card style={{ height: '100%' }}>
                              <CardContent>
                                <Grid item lg={12} xs={12} container>
                                  <Grid
                                    item
                                    lg={12}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="left"
                                  >
                                    <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#F28026", width: '40px', height: '40px', borderRadius: 5 }}>
                                      <GoalWeightIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                                    </Grid>
                                    <Grid item>
                                      <Typography fontSize={18} lineHeight="21px" fontWeight="500">
                                        {t("mygoal.label.categoryWeight")}
                                        <BootstrapTooltip
                                          placement="right"
                                          arrow
                                          title={'Ratio of each goal categories'}
                                          style={{ marginLeft: '5px' }}
                                        >
                                          <TooltipIcon />
                                        </BootstrapTooltip>
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                <Grid container lg={12} xs={12}>
                                  <Grid lg={6} xs={12}>
                                    <Typography fontSize={16} lineHeight="21px" fontWeight="500">
                                      {t("mygoal.label.categoryRatio")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid container>
                                  <Grid item lg={12} md={12} sm={12} xs={12} sx={{ width: "100%" }}>
                                    <Box sx={{ ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                                      <ApexCharts options={weightObject} series={weightSeries} type="bar" height="100px" id="apexchart" width={apexChartWidth} />
                                    </Box>
                                  </Grid>
                                </Grid>
                                {categoryRatio.map((item, key) => {
                                  return (
                                    <Grid key={key} container lg={12} xs={12} direction="row">
                                      <Grid item mt={1} style={{ marginRight: '5px' }}>
                                        <Box style={{ backgroundColor: `${item.color}`, width: 10, height: 10, borderRadius: 5 }}></Box>
                                      </Grid>
                                      <Grid item lg={5} xs={12}>
                                        <Typography fontSize={14} variant="label" fontWeight="300">
                                          {item.name}
                                        </Typography>
                                      </Grid>
                                      <Grid item lg={2}></Grid>
                                      <Grid item xs="auto">
                                        <Typography fontSize={14} variant="label" fontWeight="300">
                                          {`${item.weight}%`}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  )
                                })}
                                <Divider style={{ marginTop: 25, marginBottom: 25 }} />
                                <Grid container direction="row" alignItems="right" justifyContent="flex-end" textAlign="right" style={{ justifyContent: 'flex-end' }}>
                                  <Grid xs={2} item>
                                    <Typography fontWeight="bolder" fontSize={16} >
                                      {t("mygoal.label.total")}
                                    </Typography>
                                  </Grid>
                                  <Grid xs={1} item>
                                    <Typography fontWeight="bolder" fontSize={16} style={{ color: 'rgb(93, 161, 150)' }}>
                                      {ratio}%
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                        <Grid container mt={1} spacing={4}>
                          <Grid item lg={12} xs={12}>
                            <Card style={{ height: '100%' }}>
                              <CardContent>
                                <Grid container>
                                  <Grid
                                    item
                                    lg={6}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="left"
                                  >
                                    <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#F28026", width: '40px', height: '40px', borderRadius: 5 }}>
                                      <GoalWeightIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                                    </Grid>
                                    <Grid item>
                                      <Typography fontSize={18} lineHeight="21px" fontWeight="500">
                                        {t("mygoal.label.myGoalList")}
                                      </Typography>
                                      <Typography fontSize={14} fontWeight="fontWeightLight" variant="label">
                                        {`${t("mygoal.label.totalGoal")}: ${goalListTotal} ${t("mygoal.label.goalUnit")}`}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                <Grid item lg={12} xs={12} container>
                                  <Grid
                                    item
                                    lg={4}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="left"
                                  >
                                    <Grid item direction="row">
                                      <Typography fontSize={14} lineHeight="21px" fontWeight="500" style={{ marginLeft: '20px' }} variant="label">
                                        {t("mygoal.label.goalItem")}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={1}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="right"
                                    justifyContent='flex-end'
                                  >
                                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" variant="label">
                                      {t("mygoal.label.weight")}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={1}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="right"
                                    justifyContent='flex-end'
                                  >
                                  </Grid>
                                  <Grid
                                    item
                                    lg={2}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="center"
                                    justifyContent='center'
                                  >
                                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" style={{ marginRight: '15px' }} variant="label">
                                      {t("mygoal.label.status")}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={2}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="center"
                                    justifyContent='center'
                                  >
                                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" style={{ marginRight: '15px' }} variant="label">
                                      {t("mygoal.label.goalProgress")}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={2}
                                    xs={12}
                                    display="flex"
                                    alignItems="center"
                                    textAlign="center"
                                    justifyContent='center'
                                  >
                                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" variant="label">
                                      {t("mygoal.label.lastUpdate")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                {approvalData.goal_list.map((item, key) => {
                                  let category_weight = item.goal_items.reduce((sum, value) => parseFloat(sum) + parseFloat(value.weight), 0)
                                  //if (category_weight > 100) category_weight = 100

                                  //console.log('category_weight', item.name, category_weight, item.weight)
                                  return (
                                    <Box key={key}>
                                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                      <Grid container lg={12} xs={12} onClick={() => { handleSetExpandSummary(key) }} style={{ cursor: 'pointer' }}>
                                        <Grid lg={4} xs={12} item>
                                          <Grid container direction="row">
                                            <Grid item xs={1}>
                                              {
                                                showSummary.includes(key)
                                                  ?
                                                  <ArrowBottom style={{ paddingTop: "5px", paddingBottom: "5px", marginRight: '19px' }} />
                                                  :
                                                  <ArrowRight style={{ paddingTop: "5px", paddingBottom: "5px", marginRight: '19px' }} />
                                              }
                                            </Grid>
                                            <Grid item xs={11}>
                                              <Typography style={{ alignItems: 'center' }} fontWeight="500">
                                                {item.name}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid lg={1} xs={12}>
                                          <Typography style={category_weight !== 100 ? { color: '#CC6058', textAlign: 'right' } : { color: '#5DA196', textAlign: 'right' }}>
                                            {`${category_weight.toFixed(2)}%`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                      <Box style={{ overflowY: item.goal_items.length > 0 ? 'auto' : 'none', maxHeight: '150px', marginTop: '8px' }}>
                                        {showSummary.includes(key)
                                          ?
                                          item.goal_items.length > 0
                                            ?
                                            item.goal_items.map((list, key) => {
                                              return (
                                                <Grid key={key} container lg={12} xs={12} style={{ alignItems: 'center' }} mb={1}>
                                                  <Grid lg={4} xs={12} pl={3}>
                                                    <Typography fontSize={14} lineHeight="21px" fontWeight="400" style={{ marginLeft: '20px' }}>
                                                      {list.name}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid lg={1} xs={12}>
                                                    <Typography fontSize={14} lineHeight="21px" fontWeight="400" style={{ textAlign: 'right' }}>
                                                      {`${list.weight}%`}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid lg={1} xs={12}>
                                                  </Grid>
                                                  <Grid lg={2} xs={12} style={{ textAlign: 'center' }}>
                                                    {statusBox(list.goal_status?.description, true)}
                                                  </Grid>
                                                  <Grid lg={2} xs={12} style={{ textAlign: 'center' }}>
                                                    {statusBox(Object.keys(list.progress_status).length > 0 ? list.progress_status : goalProgressMockup, true)}
                                                  </Grid>
                                                  <Grid lg={2} xs={12}>
                                                    <Typography fontSize={14} lineHeight="21px" fontWeight="400" style={{ textAlign: 'center' }}>
                                                      {list.updated_at}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              )
                                            })
                                            :
                                            <Grid item lg={12} xs={12} style={{ textAlign: 'center', paddingTop: 15, paddingBottom: 50 }}>
                                              <Box>
                                                <img src={fileBrowser} alt="browser" />
                                              </Box>
                                              <Box>
                                                <Typography variant="sub_label">{t("mygoal.label.noData")}</Typography>
                                              </Box>
                                            </Grid>
                                          :
                                          <Box>
                                          </Box>
                                        }
                                      </Box>
                                    </Box>
                                  )
                                })}
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </StylePaper>
              }
            </Grid>

            {/* right box - stepper */}
            <Grid
              item
              xs={toggleSteppers ? 3 : "auto"}
              sm={toggleSteppers ? 3 : "auto"}
              md={toggleSteppers ? 3 : "auto"}
              lg={toggleSteppers ? 3 : "auto"}
            >
              <StylePaper
                elevation={3}
                sx={{
                  marginLeft: "auto",
                  padding: "20px",
                  width: toggleSteppers ? "100%" : "fit-content",
                }}
              >
                <Box sx={{ maxWidth: 400 }} id="steppers">
                  <Box sx={{ display: "flex" }}>
                    {toggleSteppers ? (
                      <Typography variant="h3">{t("inbox.label.status")}</Typography>
                    ) : (
                      <></>
                    )}
                    <Button
                      size="small"
                      color="black"
                      variant="outlined"
                      sx={{
                        width: "30px",
                        height: "30px",
                        padding: "0",
                        minWidth: "auto",
                        marginLeft: "auto",
                      }}
                      onClick={handleSteppersTransition}
                    >
                      {toggleSteppers ? (
                        <MinimizeIcon></MinimizeIcon>
                      ) : (
                        <MaximizeIcon></MaximizeIcon>
                      )}
                    </Button>
                  </Box>
                  <Stepper
                    orientation="vertical"
                    sx={{
                      flexDirection: "column-reverse",
                      overflow: "auto",
                      maxHeight: "inherit",
                      marginTop: "10px",
                    }}
                    connector={
                      toggleSteppers ? (
                        <StepConnector />
                      ) : (
                        <StepConnector sx={{ margin: "0 auto" }} />
                      )
                    }
                  >
                    {workflow.length > 0 ? (
                      workflow.map((step, index) => (
                        <Step
                          key={step.label}
                          expanded={true}
                          active={step.active}
                          last={index == 0 ? true : false}
                          sx={
                            !toggleSteppers
                              ? { display: "flex", margin: "0 auto" }
                              : {}
                          }
                        >
                          <StepLabel
                            StepIconProps={{
                              classes: {
                                active:
                                  step.stepStatus === "inprogress"
                                    ? classes.processText
                                    : step.stepStatus === "completed"
                                      ? classes.completedText
                                      : step.stepStatus === "rejected"
                                        ? classes.redText
                                        : classes.grayText,
                                text: !step.active ? classes.stepTextRoot : "",
                              },
                            }}
                            classes={{
                              iconContainer: toggleSteppers
                                ? classes.paddingRight_8
                                : classes.paddingRight_0,
                            }}
                          >
                            {toggleSteppers ? (
                              <Typography fontWeight={600}>
                                {step.position}
                              </Typography>
                            ) : (
                              ""
                            )}
                          </StepLabel>
                          {toggleSteppers ? (
                            step.mark === "approver" ? (
                              (step.employee ?? false) &&
                                (step.employee.length > 0 ?? false) ? (
                                step.employee.map((item, index) => {
                                  let isDivide =
                                    step.employee.length - 1 === index
                                      ? false
                                      : true;
                                  {
                                    /* console.log(step.stepStatus)  */
                                  }
                                  return (
                                    <CustomStepContent
                                      data={item}
                                      readmore={handleOpenReadMoreDialog}
                                      divider={isDivide}
                                    />
                                  );
                                })
                              ) : (
                                <></>
                              )
                            ) : (
                              <CustomStepContent
                                data={step}
                                readmore={handleOpenReadMoreDialog}
                                divider={false}
                              />
                            )
                          ) : (
                            <></>
                          )}
                        </Step>
                      ))
                    ) : (
                      <></>
                    )}
                  </Stepper>
                </Box>
              </StylePaper>
            </Grid>
          </Grid>
          <ConfirmDialog
            open={openRejectConfirmDialog}
            action={handleReject}
            setValue={handleCloseRejectConfirmDialog}
            type="reject"
            title={t("inbox.label.dialog.rejectApproval")}
            text={t("inbox.label.dialog.sureRejectApproval")}
          />
          <ConfirmDialog
            open={openApproveConfirmDialog}
            action={handleApproval}
            setValue={handleCloseApproveConfirmDialog}
            type="approve"
            title={t("inbox.label.dialog.confirmApproval")}
            text={t("inbox.label.dialog.sureConfirmApproval")}
          />
          <ConfirmDialog
            open={openCancelConfirmDialog}
            action={handleCancel}
            setValue={handleCloseCancelConfirmDialog}
            type="reject"
            title={t("inbox.label.dialog.withdrawApproval")}
            text={t("inbox.label.dialog.sureWithdrawApproval")}
          />
          <ConfirmDialog
            open={openCancelPendingConfirmDialog}
            action={handlePendingCancel}
            setValue={handleCloseCancelPendingConfirmDialog}
            type="reject"
            title={t("inbox.label.dialog.pendingCancelApproval")}
            text={t("inbox.label.dialog.surePendingCancelApproval")}
          />
          <ConfirmDialog
            open={openCancelCancelConfirmDialog}
            action={handleCancelCancel}
            setValue={handleCloseCancelCancelConfirmDialog}
            type="reject"
            title={t("inbox.label.dialog.cancelCancelApproval")}
            text={t("inbox.label.dialog.sureCancelCancelApproval")}
          />

          <MessageDialog
            open={openSucceedMessageDialog}
            setValue={handleCloseSucceedMessageDialog}
            type="success"
            title={t("inbox.label.dialog.success")}
            text={messageSuccess}
          />
          <MessageDialog
            open={openFailedMessageDialog}
            setValue={handleCloseFailedMessageDialog}
            type="fail"
            title={t("inbox.label.dialog.fail")}
            text={failMessage}
          />
          <ReadMoreDialog
            open={openReadMoreDialog}
            setValue={handleCloseReadMoreDialog}
            title={t("inbox.label.dialog.comment")}
            data={readMoreComment}
            type={params?.feedback}
          />
          {/* new */}
          <ConfirmDialogFeedback
            open={confirmSubmit}
            warning={true}
            doConfirm={() => doConfirmSubmit()}
            setValue={() => setConfirmSubmit(false)}
            title={t("label.confirmation")}
            text={t("label.sendTheFeedback")} />
          <SimpleDialog
            open={isSuccessAddDialogOpen}
            // doDirect={() => loadFeedback()}
            doDirect={() => navigate("/kpi/inbox")}
            setValue={e => openSuccessAddDialog(false)}
            text={t('label.feedbackSendSuccessfully')}
            page={true}
            subTitle=""
          />

          <ConfirmDialog
            action={actionReject}
            open={openConfirmRejectPerformanceEvaliation}
            setValue={setOpenConfirmRejectPerformanceEvaliation}
            type="reject"
            text={t('label.rejectThisRequest')}
            title={t("label.confirmation")} />

          <SimpleDialog
            open={isSuccessRejectDialogOpen}
            // doDirect={() => loadFeedback()}
            doDirect={() => navigate("/kpi/inbox")}
            setValue={e => openSuccessRejectDialog(false)}
            text={t('label.feedbackRejectSuccessfully')}
            page={true}
            subTitle=""
          />
        </Container>
      </Box>
    </>
  );
};
export default InboxDetail;